/**
 * Utilitaires de formatage des dates — Show Événement
 * Format cible : JJ-MM-AAAA (ex: 25-05-2026)
 */

/**
 * Formate une date en JJ/MM/AAAA
 * @param {string|Date} input - Chaîne ISO ou objet Date
 * @returns {string} ex: "25/05/2026"
 */
export function formatDate(input) {
  if (!input) return '—';
  try {
    const d = typeof input === 'string' ? new Date(input.length === 10 ? input + 'T12:00:00' : input) : input;
    if (isNaN(d.getTime())) return '—';
    const day   = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year  = d.getFullYear();
    return `${day}/${month}/${year}`;
  } catch {
    return '—';
  }
}

/**
 * Formate une date avec le jour de la semaine : "Lun. 25/05/2026"
 */
export function formatDateWithDay(input) {
  if (!input) return '—';
  try {
    const d = typeof input === 'string' ? new Date(input.length === 10 ? input + 'T12:00:00' : input) : input;
    if (isNaN(d.getTime())) return '—';
    const day = d.toLocaleDateString('fr-FR', { weekday: 'short' });
    return `${day} ${formatDate(d)}`;
  } catch {
    return '—';
  }
}

/**
 * Formate une date courte : "25/05" (sans année)
 */
export function formatDateShort(input) {
  if (!input) return '—';
  try {
    const d = typeof input === 'string' ? new Date(input.length === 10 ? input + 'T12:00:00' : input) : input;
    if (isNaN(d.getTime())) return '—';
    const day   = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    return `${day}/${month}`;
  } catch {
    return '—';
  }
}

/**
 * Formate une date + heure : "25/05/2026 à 14:30"
 */
export function formatDateTime(input) {
  if (!input) return '—';
  try {
    const d = typeof input === 'string' ? new Date(input) : input;
    if (isNaN(d.getTime())) return '—';
    const time = d.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });
    return `${formatDate(d)} à ${time}`;
  } catch {
    return '—';
  }
}

/**
 * Formate mois + année : "Mai 2026"
 */
export function formatMonthYear(input) {
  if (!input) return '—';
  try {
    const d = typeof input === 'string' ? new Date(input) : input;
    if (isNaN(d.getTime())) return '—';
    return d.toLocaleDateString('fr-FR', { month: 'long', year: 'numeric' });
  } catch {
    return '—';
  }
}
